module.exports = __webpack_public_path__ + "img/e606ca644fa803c2a013bc169626d34f.78c188c6.jpg";